export const COMPONENT_TYPES = {
  TEXTAREA: 'textarea',
  SELECT: 'select',
  AUTO_QUERY_SELECT: 'auto-query-select',
  NESTED_SELECT: 'nested-select',
  NESTED_PICKER: 'nested-picker',
  USER_SELECT: 'user-select',
  HOUSE_SELECT: 'house-select',
  ENTITY_SELECT: 'entity-select',
  BOOLEAN_SELECT: 'boolean-select',
  CHECKBOX: 'checkbox',
  SWITCH: 'SWITCH',
  DATEPICKER: 'datepicker',
  PHONE_INPUT: 'phone-input',
  PASSWORD_INPUT: 'password-input',
  NUMBER: 'number',
  INPUT: 'input',
  RADIO: 'radio'
}
